import React from "react";
import "@/components/textAnimPreview.css";
import { previewStyleFor } from "@/lib/textAnimationPresets";

const WORDS = ["Lorem", "ipsum", "text"];
const DUR = "2.6s";

// Map a preset to a CSS keyframe family for its motion preview.
function familyFor(preset) {
  const p = (preset && preset.patch) || {};
  if (preset && preset.id === "none") return "none";
  if (p.letterMode === "fade") return "letter-fade";
  if (p.letterMode === "scale") return "letter-scale";
  if (p.animation === "typewriter") return "type";
  const map = {
    "slide-up": "tapslideup", "slide-down": "tapslidedown", "slide-left": "tapslideleft",
    "slide-right": "tapslideright", "rise": "taprise", "staggered-rise": "taprise", "drop": "tapdrop",
    "pop": "tappop", "bouncy": "tappop", "punch": "tappop", "kinetic": "tappop", "scale": "tapscale",
    "word-blur": "tapblur", "blur": "tapblur", "motion-blur": "tapblur", "flip": "tapflip",
    "wave": "wave", "fade": "tapfade", "minimal": "tapfade",
  };
  return map[p.animation] || "tapfade";
}

export default function PresetPreview({ preset }) {
  const fam = familyFor(preset);
  const textStyle = previewStyleFor(preset);

  if (fam === "type") {
    return <span className="tap-type" style={{ ...textStyle, fontWeight: 800 }} data-testid="preset-preview-type">Lorem ipsum</span>;
  }
  if (fam === "letter-fade" || fam === "letter-scale") {
    const kf = fam === "letter-scale" ? "tapscale" : "tapfade";
    const chars = "Lorem ipsum".split("");
    let ci = 0;
    return (
      <span className="tap-prev tap-letter" style={{ fontWeight: 800 }}>
        {chars.map((ch, i) => {
          const delay = ch === " " ? 0 : (ci++ * 0.09);
          return <span key={i} className="tw" style={{ ...textStyle, whiteSpace: "pre", animation: ch === " " ? "none" : `${kf} ${DUR} ${delay}s infinite` }}>{ch}</span>;
        })}
      </span>
    );
  }
  if (fam === "none") {
    return <span className="tap-prev tap-none" style={{ ...textStyle, fontWeight: 800 }}>Lorem ipsum</span>;
  }
  return (
    <span className="tap-prev" style={{ fontWeight: 800 }}>
      {WORDS.map((w, i) => {
        const kf = fam === "wave" ? (i % 2 ? "tapwaveB" : "tapwaveA") : fam;
        return <span key={i} className="tw" style={{ ...textStyle, animation: `${kf} ${DUR} ${i * 0.28}s infinite` }}>{w}</span>;
      })}
    </span>
  );
}
